/**
 * Created by mac on 2/3/20
 */

const HomefixLocation = function (locationConfig, slot) {
    cleverapps.EventEmitter.call(this);

    this.slot = slot;

    this.locationConfig = locationConfig;
    this.locationId = locationConfig.locationId;

    this.families = Families.listExpeditionCodes(this.locationConfig.unknown ? "unknown" : this.locationId);

    this.stars = this.slot.load("stars") || 0;
};

HomefixLocation.prototype = Object.create(cleverapps.EventEmitter.prototype);
HomefixLocation.prototype.constructor = HomefixLocation;

HomefixLocation.prototype.getMigratedStars = function () {
    if (this.locationId !== 0 || this.slot.load("stars") !== undefined || cleverapps.user.getHumanReadableNumber() < 2) {
        return;
    }

    const maxStars = 50;
    const levelsToPassLocation = 210;
    return Math.min(
        maxStars,
        Math.ceil(cleverapps.user.getHumanReadableNumber() * maxStars / levelsToPassLocation)
    );
};

HomefixLocation.prototype.complete = function () {
    this.completed = true;
};

HomefixLocation.prototype.isCompleted = function () {
    return this.completed;
};

HomefixLocation.prototype.gamePlayed = function (game) {
    if (game.outcome !== GameBase.OUTCOME_VICTORY) {
        return;
    }

    game.rewards.metaStar = game.level.isHard() ? 3 : 1;

    cleverapps.user.incPhysicalLevel();
};

HomefixLocation.prototype.getProgress = function () {
    let goal = 0;
    let current = 0;
    Homefix.currentHomefix.getFurniture().forEach((furniture) => {
        furniture.stages.forEach((stage) => {
            goal += stage.cost;
            if (furniture.id <= Homefix.currentHomefix.furnitureId) {
                current += stage.cost;
            }
        });
    });
    return current / goal * 100;
};

HomefixLocation.prototype.changeStars = function (stars, silent) {
    this.stars += stars;

    this.slot.save("stars", this.stars);

    if (!silent) {
        this.onChangeStars(stars);
    }
};

HomefixLocation.prototype.resetStars = function () {
    const stars = this.stars;
    this.stars = 0;
    this.onChangeStars(-stars);
};

HomefixLocation.prototype.onChangeStars = function (stars) {
    cleverapps.meta.trigger("changeStars", stars);
};

HomefixLocation.prototype.getLocationCompleteReward = function () {
    return {
        hard: 200
    };
};

HomefixLocation.GetMainScene = function () {
    return bundles.main.jsons.homefixscene_prefab_json;
};
